<div class="exception-body access">
  <div class="exception-content">
    <div class="moon">
      <img
        src="../../../../assets/layout/images/pages/asset-moon.svg"
        alt="mirage-layout"
        />
    </div>
    <div class="exception-panel">
      <div class="exception-panel-content">
        <span class="tag">401</span>
        <h1>{{ loggedIn ? 'Access Denied' : 'Login Error' }}</h1>
        <div class="seperator mb-6"></div>
        @if (loggedIn) {
          <p>You do not have the necessary permissions. Please contact support if you feel this is in error.</p>
        }
        <a
          pButton
          type="button"
          [href]="loggedIn ? '/productivity/tasks' : AuthPath"
          [label]="loggedIn ? 'Go to Tasks page' : 'Go to Login page'"
        ></a>
      </div>
    </div>
    <div class="desert"></div>
  </div>
</div>
